import { BaseModel } from '../base-model';
import { IItemStateModel } from '../base-itemstate';

export interface IPropertyPictureModel extends IItemStateModel {
  PropertyId?: number;
  PictureNumber ?: number;
    PictureTypeIds?: PropertyArrayTypeModel[];
    PictureRoomIds?: PropertyArrayTypeModel[];
  DescriptionOfNL ?: string;
  DescriptionOfSP  ?: string;
  DescriptionOfCA ?: string;
  DescriptionOfEN ?: string;
  DescriptionOfDE ?: string;
  DescriptionOfFR ?: string;
  OriginalUrl?: string;
  SmallUrl?: string;
  MediumUrl?: string;
  LargeUrl?: string;
  XLargeUrl?: string;
  Id?: number;
  ItemState?: number;
  WidthOfImage?: number;
  HeightOfImage ?: number;
  PublishOnInternet?: boolean;
  IsMissingOnCloud?: boolean;
  SmallPublishUrl?: string;
  OriginalPublishUrl?: string;
    TempId?: string;
    updateKey?: string;
}
export class PropertyPictureModel extends BaseModel<IPropertyPictureModel> implements IPropertyPictureModel {
  PropertyId?: number;
  PictureNumber ?: number;
    PictureTypeIds?: PropertyArrayTypeModel[];
    PictureRoomIds?: PropertyArrayTypeModel[];
  DescriptionOfNL ?: string;
  DescriptionOfSP  ?: string;
  DescriptionOfCA ?: string;
  DescriptionOfEN ?: string;
  DescriptionOfDE ?: string;
  DescriptionOfFR ?: string;
  
  OriginalUrl?: string;
  SmallUrl?: string;
  MediumUrl?: string;
  LargeUrl?: string;
  XLargeUrl?: string;
  Id?: number;
  ItemState?: number;
  WidthOfImage?: number;
  HeightOfImage ?: number;
  PublishOnInternet?: boolean;
  IsMissingOnCloud?: boolean; 
  SmallPublishUrl?: string;
    OriginalPublishUrl?: string;
    TempId?: string;
    updateKey?: string;
  /**
   *
   */
  constructor(option?: IPropertyPictureModel) {
    super(option);

  }
}

/**
 * UPDATE WITH SPECIFIC FIELD
 */
export class PropertyPictureUpdateModel  {
  Id: number;
  Field: string;
  Value: object
}

/**
 * UPDATE WITH PROPERTY IS ARRAY
 */
export class PropertyArrayPictureUpdateModel  {
  Id: number;
  Field: string;
  Value: number[];
  IsJustAddRoomed?: boolean;
}

/** DEFINE PROPERTY ARRAY */
export class PropertyArrayTypeModel{
  Id: number;
  ItemState?: number;
  OrderNr?: number;
    TempId?: number;
}